import { ImageStatus } from "../api/imageApi";

export class ImageForUpload {
  constructor(imgObj) {
    this.crop_image = imgObj.crop_image;
    this.original_image = imgObj.original_image;
    this.crop_params = imgObj.crop_params;
    this.ordinal = imgObj.ordinal;
    this.extra_info = imgObj.extra_info;
    this.status = ImageStatus.PENDING;
  }
}

export class UploadedImage {
  constructor(imgObj) {
    if (imgObj.id) {
      this.id = imgObj.id;
    }
    this.crop_params = imgObj.crop_params;
    this.ordinal = imgObj.ordinal;
    this.original_url = imgObj.original_url;
    this.src = imgObj.crop_url;
    this.status = ImageStatus.UPLOADED;
  }
}
